import { Box, Tab, Tabs, styled} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { TabPanel } from './tabPanel';
import _ from 'lodash';

import Roles from './EIComponents/Roles';
import Chat from './EIComponents/Chat';
import Logs from './EIComponents/Logs';
import Worker from './EIComponents/Worker';
import Deal from './EIComponents/Deal';
import DealClient from './EIComponents/DealClient';
import MoveGuide from './EIComponents/MoveGuide';
import CliInfo from './EIComponents/CliInfo';
import ProductInfo from './EIComponents/ProductInfo';
import WorkerClient from './EIComponents/WorkerClient';

import ClientDocumentsSettings from "pages/ClientDocumentsSettings.js";
import ClientSettings from "pages/ClientSettings.js";
import ClientAPISettings from "pages/ClientAPISettings.js";
import UnityTotal from './EIComponents/UnityTotal';
import UnityDealList from './EIComponents/UnityDealList';
import ReturnsDealList from './EIComponents/ReturnsDealList';


export function useAdaptiveTabsFont(options = {}) {
  const { min = 12, max = 28, ratio = 0.04 } = options;
  const containerRef = useRef(null);

  useEffect(() => {
    /** @type {any} */
    const container = containerRef.current;
    if (!container) return;

    const updateFontSize = (width) => {
      let newSize = width * ratio;
      newSize = Math.min(max, Math.max(min, newSize));
      container.style.setProperty('--tabs-font-size', `${newSize}px`);
    };

    const resizeObserver = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      updateFontSize(width);
    });

    resizeObserver.observe(container);
    updateFontSize(container.clientWidth);

    return () => resizeObserver.disconnect();
  }, [min, max, ratio]);

  return { containerRef };
}

const EITab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: "#808080",
    transition: "all 0.2s ease-in-out",
    fontSize: "var(--tabs-font-size, 18px)", 

    fontWeight: 'normal',
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '30px', // вместо стандартных 48px
    height: "30px",
    
    // Способ 2: Уменьшение отступов внутри компонента
    // padding: '12px 20px', // вместо стандартных 12px 16px
    marginLeft: "2px",
    marginRight: "2px",

    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        color: "#078376",
        fontWeight: 'normal',//'bold',
    },
}));

//fy sr.gay
export function ElementInfo({ds, data={}, onClose=undefined, setChanged = () => {}, reload=undefined}) {    
  const [tabIdx, setTabIdx] = useState(ds?.descr?.defaultTab || "");
  // @ts-ignore
  // @ts-ignore
  const handleChange = (event, newValue) => setTabIdx(newValue);
  const { containerRef } = useAdaptiveTabsFont({ min: 12, max: 45, ratio: 0.04 });

  console.log("ds", ds)
  console.log("EI DATA", data)
  console.log("TID", tabIdx)
  return (
    <Box
      component="div" 
      style={{ width: '35vw', height: '100vh',padding:'1%',overflow: "hidden"}}
    >     
      {ds?.descr?.header &&
        <div style={{height: "10%"}}>
          {ds.descr.header(data)}
        </div>
      }
      {
        ds?.descr?.tabs && 
        <>
          <Box 
            ref={containerRef} 
            component="div" 
            sx={{ 
              borderBottom: 0, 
              borderColor: 'divider', 
              backgroundColor: '#f0f0f0',
              display: 'flex',
              alignItems: 'flex-end',
            }}
          >
            <Tabs 
              value={tabIdx} 
              aria-label="basic tabs example" 
              onChange={handleChange}
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{ 
                minHeight: '30px', 
                width: "100%",
                // '& .MuiTabs-flexContainer': {
                //   justifyContent: 'space-between',
                // },
                "& .MuiTabs-scrollButtons": {
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    transition: 'all 0.2s ease-in-out',
                    color: '#078476',
                    '&.Mui-disabled': {
                        opacity: 0.0
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(7, 132, 118, 0.12)', // лёгкая подсветка
                        transform: 'scale(1.08)',                  // небольшое увеличение
                        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                        color: '#066b60',
                    },
                    '&:active': {
                        transform: 'scale(0.96)', // эффект нажатия
                    },
                },
            }}
            >
              {ds?.descr?.tabs.includes('common') && (<EITab label='ОСНОВНОЕ' value={'common'} />)}
              {ds?.descr?.tabs.includes('chat') && <EITab label='Чат' value={'chat'} />}
              {ds?.descr?.tabs.includes('logs') && (<EITab label='ЛОГИ' value={'logs'} />)}
              {ds?.descr?.tabs.includes('worker') && <EITab label='Сотрудник' value={'worker'} />}
              {ds?.descr?.tabs.includes('clientWorker') && <EITab label='Сотрудник' value={'clientWorker'} />}
              {ds?.descr?.tabs.includes('roles') && <EITab label='Роли' value={'roles'} />}
              {ds?.descr?.tabs.includes('CreateDelivery') && <EITab label='Поставка' value={'CreateDelivery'} />}
              {ds?.descr?.tabs.includes('CliInfo') && <EITab label='Информация о клиенте' value={'CliInfo'} />}
              {ds?.descr?.tabs.includes('moveGuide') && <EITab label='Сбор товара' value={'moveGuide'} />}
              {ds?.descr?.tabs.includes('productInfo') && <EITab label='Товар' value={'productInfo'} />}
              {ds?.descr?.tabs.includes('ClientSettings') && <EITab label='Основное' value={'ClientSettings'} />}
              {ds?.descr?.tabs.includes('ClientDocumentsSettings') && <EITab label='Реквизиты' value={'ClientDocumentsSettings'} />}
              {ds?.descr?.tabs.includes('ClientAPISettings') && <EITab label='Интеграция по API' value={'ClientAPISettings'} />}
              {ds?.descr?.tabs.includes('unity_deal_deals') && <EITab label='Сделки' value={'unity_deal_deals'} />}
              {ds?.descr?.tabs.includes('unity_deal') && <EITab label='Товары' value={'unity_deal'} />}
              {ds?.descr?.tabs.includes('returns_deals') && <EITab label='Возвраты' value={'returns_deals'} />}
              {ds?.descr?.tabs.includes('selfreturns_deals') && <EITab label='Самовыкупы' value={'selfreturns_deals'} />}
            </Tabs>
          </Box>

          <div style={{height: ds.descr.header? "93%": "98%"}}>
            <TabPanel select={tabIdx} value={'common'}>
              <Deal ds={ds} deal_id={data} setChanged={setChanged} reload={reload}/>
            </TabPanel>

            <TabPanel select={tabIdx} value={'chat'}>
              <Chat data={[]}/>
            </TabPanel>
            <TabPanel select={tabIdx} value={'logs'}>
              <Logs deal_id = {data}/>
            </TabPanel>

            <TabPanel select={tabIdx} value={'clientWorker'}>
              <WorkerClient data = {data} onClose = {onClose} setChanged = {setChanged}/>
            </TabPanel>

            <TabPanel select={tabIdx} value={'worker'}>
              <Worker data = {data} onClose = {onClose} setChanged = {setChanged}/>
            </TabPanel>

            <TabPanel select={tabIdx} value={'roles'}>
              <Roles data={data} ds={ds} setChanged = {setChanged}/>
            </TabPanel>
            
            <TabPanel select={tabIdx} value={'CreateDelivery'}>
              <DealClient ds = {ds} deal_id = {data}/>
            </TabPanel>
            <TabPanel select={tabIdx} value={'moveGuide'}>
              <MoveGuide deal_id = {data}/>
            </TabPanel>
            <TabPanel select={tabIdx} value={'CliInfo'}>
              <CliInfo ds = {ds} cli_id = {data}/>
            </TabPanel>

            <TabPanel select={tabIdx} value={'ClientSettings'}>
              <ClientSettings/>
            </TabPanel>
            <TabPanel select={tabIdx} value={'ClientDocumentsSettings'}>
              <ClientDocumentsSettings />
            </TabPanel>
            <TabPanel select={tabIdx} value={'ClientAPISettings'}>
              <ClientAPISettings />
            </TabPanel>

            <TabPanel select={tabIdx} value={'productInfo'}>
              {data && <ProductInfo 
              // @ts-ignore
              targetId = {data.id} other={data.other} set={data.set} close={data.close} avaiblePackage={data.avaiblePackage} avaibleTags={data.avaibleTags} avaibleConsumes={data.avaibleConsumes} market={data.market}
              setChanged={setChanged}/>}
            </TabPanel>

            <TabPanel select={tabIdx} value={'unity_deal'}>
              <UnityTotal ds={ds} info={data} onClose = {onClose}/>
            </TabPanel>
            <TabPanel select={tabIdx} value={'unity_deal_deals'}>
              <UnityDealList ds={ds} info={data} onClose = {onClose}/>
            </TabPanel>
            <TabPanel select={tabIdx} value={'returns_deals'}>
              <ReturnsDealList ds={ds} type={'returns'}/>
            </TabPanel>
            <TabPanel select={tabIdx} value={'selfreturns_deals'}>
              <ReturnsDealList ds={ds} type={'selfreturns'}/>
            </TabPanel>
          </div>
        </>
      }

    </Box>
  );
}

